import { render, staticRenderFns } from "./RoundLimitNumbers.vue?vue&type=template&id=c3f045a0&scoped=true&"
import script from "./RoundLimitNumbers.vue?vue&type=script&lang=js&"
export * from "./RoundLimitNumbers.vue?vue&type=script&lang=js&"
import style0 from "./RoundLimitNumbers.vue?vue&type=style&index=0&id=c3f045a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f045a0",
  null
  
)

export default component.exports